import { observer } from 'mobx-react';
import React, { useRef, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';
import { useTrappingZoneTrapLures } from '../hooks/useTrappingZoneTrapLures';
import { useStores } from '../stores/useStores';

const SetupTrapsForm = ({
  handleSubmit,
  handleChange,
  handleBlur,
  setFieldValue,
  values,
  errors,
  chargedInput
}) => {
  const { traplogStore } = useStores();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const selectRef = useRef(null);

  const trappingZone = React.useMemo(
    () =>
      traplogStore.trappingZones.find(
        (zone) => zone.id === traplogStore.selectedTrappingZoneId
      ),
    [traplogStore.trappingZones, traplogStore.selectedTrappingZoneId]
  );
  const trapLures = useTrappingZoneTrapLures(trappingZone);

  const options = traplogStore.traps.map((trap) => {
    return {
      value: trap.id,
      label: `${trap.name} (${trap.code})`
    };
  });

  const handleSelectAll = () => {
    const newOptions = !allSelected ? options : [];
    selectRef.current.selectOption(newOptions);
    setFieldValue('traps', newOptions);
    setSelectedOptions(newOptions);
    setAllSelected(!allSelected);
  };

  return (
    <Form noValidate onSubmit={handleSubmit}>
      {/* Traps Select */}
      <Form.Group controlId='traps'>
        <Form.Label>Select Traps</Form.Label>
        <Row>
          <Col xs={7} sm={8} md={8}>
            <Select
              ref={selectRef}
              isMulti
              options={options}
              isLoading={traplogStore.loadingTrappingZones}
              value={selectedOptions}
              onChange={(options) => {
                setFieldValue('traps', options);
                setSelectedOptions(options);
              }}
              onBlur={() => {
                handleBlur({ target: { name: 'traps' } });
              }}
            />
          </Col>
          <Col className='text-center' xs={5} sm={4} md={4}>
            <Button
              variant='success'
              onClick={() => {
                handleSelectAll();
              }}
            >
              {!allSelected ? 'Select All' : 'Unselect All'}
            </Button>
          </Col>
        </Row>
        {errors.traps ? (
          <div className='text-danger' style={{ fontSize: '80%' }}>
            {errors.traps}
          </div>
        ) : null}
      </Form.Group>
      {/* Setup Date */}
      <Form.Group controlId='setup_date'>
        <Form.Label>Setup Date</Form.Label>
        <Form.Control
          type='date'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.setup_date}
          isInvalid={errors.setup_date}
        />
        <Form.Control.Feedback type='invalid'>
          {errors.setup_date}
        </Form.Control.Feedback>
      </Form.Group>
      {/* Charged Date */}
      {chargedInput ? (
        <Form.Group controlId='charged_date'>
          <Form.Label>Charged Date</Form.Label>
          <Form.Control
            type='date'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.charged_date}
            isInvalid={errors.charged_date}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.charged_date}
          </Form.Control.Feedback>
        </Form.Group>
      ) : null}
      {/* Trap Lure */}
      <Form.Group controlId='trap_lure'>
        <Form.Label>Trap Lure</Form.Label>
        <Select
          options={trapLures.map((trapLure) => {
            return {
              value: trapLure.id,
              label: `${trapLure.name} x ${trapLure.concentration}`
            };
          })}
          isLoading={traplogStore.loadingTrapLures}
          defaultValue={values.trapLure}
          onChange={(option) => setFieldValue('trap_lure', option)}
        />
        {errors.trapLure ? (
          <div className='text-danger'>{errors.trap_lure}</div>
        ) : null}
      </Form.Group>
    </Form>
  );
};

export default observer(SetupTrapsForm);
